import { render, staticRenderFns } from "./innovationPointsSystem.vue?vue&type=template&id=ce0fbea2&scoped=true&"
import script from "./innovationPointsSystem.vue?vue&type=script&lang=js&"
export * from "./innovationPointsSystem.vue?vue&type=script&lang=js&"
import style0 from "./innovationPointsSystem.vue?vue&type=style&index=0&id=ce0fbea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0fbea2",
  null
  
)

export default component.exports